'use client';

import { c as _c } from "react/compiler-runtime";
import { CustomButton } from '@/shared/ui/molecules';
import { Typography } from '@/shared/ui/atoms';
import { useRef } from 'react';
import { PARTNER_HOSPITAL_TAB_DEFS, usePartnerHospitalTabScrollSync } from '@/widgets/hospital/lib/usePartnerHospitalTabScrollSync';
import { useTranslations } from 'next-intl';
const PartnerHospitalTabs = () => {
  const $ = _c(9);
  const t = useTranslations();
  const tabsRef = useRef(null);
  const {
    selectedTab,
    stickyTop,
    handleTabClick
  } = usePartnerHospitalTabScrollSync(tabsRef);
  let t0;
  if ($[0] !== stickyTop) {
    t0 = {
      top: stickyTop
    };
    $[0] = stickyTop;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== handleTabClick || $[3] !== selectedTab || $[4] !== t) {
    t1 = PARTNER_HOSPITAL_TAB_DEFS.map(tab => <CustomButton key={tab.value} className={`shrink-0 whitespace-nowrap rounded-full px-[14px] py-1.5 ${selectedTab === tab.value ? "bg-gray-700" : "bg-gray-100"}`} onClick={() => handleTabClick(tab.value)}><Typography size={15} lineHeight={22} className={`${selectedTab === tab.value ? "text-white" : "text-gray-900"}`}>{t(tab.messageKey)}</Typography></CustomButton>);
    $[2] = handleTabClick;
    $[3] = selectedTab;
    $[4] = t;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t0 || $[7] !== t1) {
    t2 = <div ref={tabsRef} className="sticky z-[101] flex w-full min-w-0 max-w-full gap-1.5 overflow-x-auto overflow-y-hidden bg-white px-4 pb-1.5 pt-4 scrollbar-hide" style={t0}>{t1}</div>;
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
export default PartnerHospitalTabs;